const weightMap = [6, 4, 14, 15, 10, 1];
const charMap = [
    'A',
    'B',
    'D',
    'F',
    'G',
    'H',
    'I',
    'K',
    'M',
    'P',
    'S',
    'T',
    'V',
    'W',
    'X',
    'Y',
    'Z',
];
export function isCommercialRegisterNumber(value) {
    if (!value) {
        return true;
    }
    const valid = /^[0-9]{1,6}[A-Za-z]$/.test(value);
    if (valid && typeof value === 'string') {
        // 6 positions are required
        const format = [0, 0, 0, 0, 0, 0];
        // map existing values into format
        [...value.slice(0, -1)]
            .map((v) => Number.parseInt(v))
            .reverse()
            .forEach((n, index) => {
            format[format.length - 1 - index] = n;
        });
        // get weighted numbers
        const weighted = format.map((c, i) => c * weightMap[i]);
        const sum = weighted.reduce((x, y) => x + y);
        // check with char table
        const checkChar = charMap[sum % 17];
        // verify checksum with last char of value
        return value.substr(-1).toUpperCase() === checkChar;
    }
    return false;
}
